import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Labels, SdfCardLabels } from '../app.models';
import { MgLocation } from '../models/location.model';
import { LocationFinderService } from '../services/location-finder.service';
import { BaseComponent } from '../shared/base.component';
import { MobileBreakPointsService } from '../services/mobileBreakPoints.service';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-locator-main',
  templateUrl: './locator-main.component.html',
  styleUrls: ['./locator-main.component.scss'],
})
export class LocatorMainComponent extends BaseComponent implements OnInit {
  originalAddressSearched: string = '';
  cashInAmount!: string;
  locationLabels!: any;
  sdfCardLabels: SdfCardLabels;

  @Output() upOnClose: EventEmitter<any> = new EventEmitter();
  @Output() locationSelected: EventEmitter<any> = new EventEmitter();
  @Input() flow: string;
  public _google: any;
  @Input() public set google(map: any) {
    this._google = map;
  }
  public get google() {
    return this._google;
  }

  public _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
    this.sdfCardLabels = labels.stellar.sdfcard;
    this.locationLabels = labels.stellar.location;
  }
  public get labels() {
    return this._labels;
  }

  constructor(
    public locationFinderService: LocationFinderService
  ) {
    super();
  }

  ngOnInit() {
    this.getLocatorLabels();
  }

  private getLocatorLabels(): void {
    this.locationFinderService.locationLabels = this.locationLabels;
  }

  public onSendLocation(location: MgLocation): void {
    this.locationSelected.emit(location);
  }
  public onSearch(address: string) {
    this.originalAddressSearched = address;
  }

  public close() {
    this.upOnClose.emit();
  }
}
